export default "__VITE_ASSET__S74SZX1Y__"